<style scoped>
    iframe {
        width: 100%;
        height: 100%;
        min-height: 100%;
    }
    .iframe-contain {
        height: 100%;
        width: 100%;
    }
</style>
<template>
  <div
    ref="iframe-contain"
    class="iframe-contain"
  >
    <Spin
      v-if="showSpin"
      size="large"
      fix
    />
    <iframe
      ref="iframe-detail"
      width="1140"
      height="541.25"
      :src="iframe_path"
      frameborder="0"
      allowFullScreen="true"
    />
  </div>
</template>
<script :route="{path: '/iframeRouter/:id',noChkout: true}">
  const SIZE_CHANGE_TIMER = Symbol('sizeChangeTimer')
  const changeSizeFun = function() {
    const _this = this
    _this[SIZE_CHANGE_TIMER] = setTimeout(function() {
      _this.setContainHeight()
      _this[SIZE_CHANGE_TIMER] = null
    }, 500)
  }
  export default {
    /* router_info_start */
    router_info:{
      path: '/iframeRouter/:id',
      noChkout: true
    },
    /* router_info_end */

    data() {
      this.resize_call = null
      return {
        iframe_path:'',
        showSpin:false
      }
    },
    mounted() {
      const vuex_state = this.$store.state
      const _this = this
      this.showSpin = true
      this.$refs['iframe-detail'].onload = () => {
        _this.showSpin = false
      }
      const { params = {} } = this.$router.currentRoute || {}
      const timer_fun = (vuex_state, _this, params) => {
        if (!Object.keys(vuex_state.menu_id_hash).length) {
          _this.timer = setTimeout(() => {
            timer_fun(vuex_state, _this, params)
          }, 300)
        } else {
          clearTimeout(_this.timer)
          if (vuex_state.menu_id_hash[params.id] === undefined) {
            _this.$router.push('/dashBoard/routerDetail')
            return
          }
          const { iframe_path } = vuex_state.menu_id_hash[params.id]
          this.iframe_path = iframe_path
          _this.timer = null
        }
      }
      timer_fun(vuex_state, _this, params)
      this.setContainHeight()
      this.resize_call = () => {
        if (_this[SIZE_CHANGE_TIMER]) {
          clearTimeout(_this[SIZE_CHANGE_TIMER])
        }
        changeSizeFun.apply(_this)
      }
      window.addEventListener("resize", _this.resize_call);
      this.grand = this.$router.afterEach((to) => {
        const { params } = to
        if (to.fullPath.includes('/iframeRouter')) {
          timer_fun(vuex_state, _this, params)
        }
      })
    },
    beforeDestroy() {
      const _this = this
      if (this.grand) {
        this.grand()
      }
      window.removeEventListener('resize', _this.resize_call)
    },
    methods: {
      setContainHeight() {
        const height = (document.documentElement.clientHeight || document.body.clientHeight)
        this.$refs['iframe-contain'].style.height = height - 135 + 'px'
      }
    }
  }
</script>
